import axios from 'axios';

import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';




const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }


export const svLoadStoredcardallBegin = () => dispatch => {
    dispatch({
        type:'GET_STOREDCARDALL_BEGIN'
        
    })
}


export const geLoadStoredcardallSuccess = (data) => dispatch => {
    dispatch({
        type: 'GET_STOREDCARDALL_SUCCESS',
        payload: data
    })
}

export const getLoadStoredcardallError = (e) =>dispatch => {
    dispatch({
        type:'GET_STOREDCARDALL_ERROR',
        payload:e
    })
}



export function deleteStoredcard_dbworkingsv(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadStoredcardallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressDelete`
        const bodyDelete = {
            "id": (nameQParam? nameQParam:3)
           }

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/addressListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
        axios.all([
            axios.post(urlDelete, bodyDelete, {headers:headers}),
            axios.post(url,body, {headers:headers})
        ])
        .then(
            axios.spread((rd,r)=>{

                if(rd['status']  == 200){
                  

                   
                    if(r.data.length>0){
                        const ar = r.data
                        const comData = { my_data_storedcardlist:  ar }
    
                        dispatch(geLoadStoredcardallSuccess(comData))
                    }
                    else {
                        const comData = { my_data_storedcardlist: []}
                        dispatch(getLoadStoredcardallError(comData))
                    }

                }
                else {
                    const comData = { my_data_storedcardlist: []}
                    dispatch(getLoadStoredcardallError(comData))
                }

            })
        )
        
       
    }

}

export function loadStoredcardListMyReservationForCustId(nameQParam ,custProfile,hdr, relUrl){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    console.log(custProfile)
    return dispatch => {
        dispatch(svLoadStoredcardallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const urlAdminAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListView`
        const bodyAdminAddressList = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
         const urlStoredcardList = `http://localhost:8086/account/cardListByCustomerIdView`
       
         const bodyStoredcardList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        let url= null, body=null

        if(custProfile && (custProfile.customerId > 0)){
            console.log('sv*****svaddreslistactiob callss  account/addressListByCustomerIdView')
            let customerId = custProfile.customerId
            bodyStoredcardList.docId.push("" + customerId)
           
            url = urlStoredcardList
            body = bodyStoredcardList
        }else{
            console.log('sv*****svaddreslistactiob callss  urlAdminAddressList')
            url = urlAdminAddressList
            body = bodyAdminAddressList
           
            console.log('custProfile + error by UI')
        }

        const svurl = relUrl ? `http://localhost:8086/${relUrl}` :url
        const svhdr = hdr ? hdr: headers 
      
        axios.post(svurl, body, {headers:svhdr})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    ar.map( (o,idx)=>{
                        
                        o['id'] = o['cardId']? o['cardId']: o['id']
                    });
                    const comData = { my_data_storedcardlist:  ar }

                    //we are lowercase aleadt

                    /*
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data_storedcardlist.push(sod)
                    });

                   */
                    dispatch(geLoadStoredcardallSuccess(comData))
                }
                else {
                    const comData = { my_data_storedcardlist: []}
                    dispatch(getLoadStoredcardallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadStoredcardallError(e))
        )
    }
}


export function loadStoredcardListMyReservationForCustIdSecure_svj31(nameQParam ,custProfile,svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    console.log(custProfile)
    return dispatch => {
        dispatch(svLoadStoredcardallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const urlAdminAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListView`
        const bodyAdminAddressList = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
         const urlStoredcardList = `http://localhost:8086/account/cardListByCustomerIdViewSecure`
       
         const bodyStoredcardList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        let url= null, body=null

        if(custProfile && (custProfile.customerId > 0)){
            console.log('sv*****svaddreslistactiob callss  account/addressListByCustomerIdView')
            let customerId = custProfile.customerId
           bodyStoredcardList.docId.push("" + customerId)
           //bodyStoredcardList.docId.push("" + 87)
            url = urlStoredcardList
            body = bodyStoredcardList
        }else{
            console.log('sv*****svaddreslistactiob callss  urlAdminAddressList')
            url = urlAdminAddressList
            body = bodyAdminAddressList
           
            console.log('custProfile + error by UI')
        }

        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
        axios.post(url, body, {headers:svheaders})
        .then(
            r => {
                if(r.data.length>0){
                    

                    const ob = r.data
                    if(ob.status && ob.status !=200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getLoadStoredcardallError(eeb))
                    }else{
                        const ar = r.data
                        ar.map( (o,idx)=>{
                            
                            o['id'] = o['cardId']? o['cardId']: o['id']
                        });
                        const comData = { my_data_storedcardlist:  ar }
    
                        //we are lowercase aleadt
    
                        /*
                        var item , ob, sod, upperOb
                        
                        ar.forEach(a_rec => {
                            item = {}
                            upperOb = a_rec
                            ob =lowercaseKeys(upperOb)
                            sod =  _.clone(ob)
    
                            
    
                            comData.my_data_storedcardlist.push(sod)
                        });
    
                       */
                        dispatch(geLoadStoredcardallSuccess(comData))
                    }
                }
                else {
                    const comData = { my_data_storedcardlist: []}
                    dispatch(getLoadStoredcardallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadStoredcardallError(e))
        )
    }
}

export function deleteStoredcard(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadStoredcardallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
       
        const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/accountcardDelete`
        const bodyDelete = {
            "id": (nameQParam? nameQParam:3)
           }

        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
       
        
         
        axios.post(urlDelete, bodyDelete, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    const comData = { my_data_storedcardlist:  ar }

                   
                    dispatch(geLoadStoredcardallSuccess(comData))
                }
                else {
                    const comData = { my_data_storedcardlist: []}
                    dispatch(getLoadStoredcardallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadStoredcardallError(e))
        )
        
    }

}



export function loadStoredcardList(nameQParam){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    return dispatch => {
        dispatch(svLoadStoredcardallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListView`
        const body = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.length>0){
                    const ar = r.data
                    ar.map( (o,idx)=>{
                        
                        o['id'] = o['cardId']? o['cardId']: o['id']
                    });
                    const comData = { my_data_storedcardlist:  ar }

                    //we are lowercase aleadt

                    /*
                    var item , ob, sod, upperOb
                    
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec
                        ob =lowercaseKeys(upperOb)
                        sod =  _.clone(ob)

                        

                        comData.my_data_storedcardlist.push(sod)
                    });

                   */
                    dispatch(geLoadStoredcardallSuccess(comData))
                }
                else {
                    const comData = { my_data_storedcardlist: []}
                    dispatch(getLoadStoredcardallError(comData))
                }
            }
        ).catch(
            e=>dispatch(getLoadStoredcardallError(e))
        )
    }
}

/*svj31 start */

export function loadStoredcardListMyReservationForCustIdSecure(nameQParam ,custProfile,svtv){
    console.log('%%%%%%%%%%%%%%%sv++++REST API For _doc swith sae key :' + nameQParam)
    console.log(custProfile)
    return dispatch => {
        dispatch(svLoadStoredcardallBegin())
        //const url = 'http://localhost:8080/essearch/sojourDetailView'
        const urlAdminAddressList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/cardListView`
        const bodyAdminAddressList = {
            "query": {
                "bool": {
                    "must": [
                        {
                            "match": {
                                "SPACE_KEY.keyword": "DN38@4@F@10@10@20231124@7@Y@EVR"
                            }
                        }
                    ]
                }
            }
         }
         const urlStoredcardList = `http://localhost:8086/account/cardListByCustomerIdViewSecure`
       
         const bodyStoredcardList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }
        let url= null, body=null

        const urlGeoList = `${SV_SOJ_ORCMOCK_ADDRESS}/account/geographyMyReservation`
         
        const bodyGeoNewList = {
            "docId": [
                
            ],
            "hsetname": "HotelInvDB"
        }

        if(custProfile && (custProfile.customerId > 0)){
            console.log('sv*****svaddreslistactiob callss  account/addressListByCustomerIdView')
            let customerId = custProfile.customerId
           bodyStoredcardList.docId.push("" + customerId)
           //bodyStoredcardList.docId.push("" + 87)
           bodyGeoNewList.docId.push("" + customerId)
            url = urlStoredcardList
            body = bodyStoredcardList
        }else{
            console.log('sv*****svaddreslistactiob callss  urlAdminAddressList')
            url = urlAdminAddressList
            body = bodyAdminAddressList
           
            console.log('custProfile + error by UI')
        }

        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
          'Content-Type': 'application/json' };
        axios.all([
            axios.post(url, body, {headers:svheaders}),
            axios.post(urlGeoList, bodyGeoNewList, {headers:headers}),
        ], {
            timeout: 7000
        }).then(
            axios.spread((r,r5)=>{

                let my_data_geo = null
                if(r5.data){
                     //svr5 start
                    
                     console.log('svj25 my_data_geo*********')
                     console.log(r5.data )
                     if( r5.data  &&  r5.data.countryTypes && r5.data.countryTypes.length>0){
                      my_data_geo = r5.data
                     
                     }
                    
                     //svr5 end
                }
                //svj31 rstart
                if(r.data.length>0){
                    

                    const ob = r.data
                    if(ob.status && ob.status !==200){
                        let eeb = {

                        }
                        eeb.errob = ob
                        dispatch(getLoadStoredcardallError(eeb))
                    }else{
                        const ar = r.data
                        ar.map( (o,idx)=>{
                            
                            o['id'] = o['cardId']? o['cardId']: o['id']
                        });
                        const comData = { my_data_storedcardlist:  ar , my_data_geo:my_data_geo }
    
                        //we are lowercase aleadt
    
                        /*
                        var item , ob, sod, upperOb
                        
                        ar.forEach(a_rec => {
                            item = {}
                            upperOb = a_rec
                            ob =lowercaseKeys(upperOb)
                            sod =  _.clone(ob)
    
                            
    
                            comData.my_data_storedcardlist.push(sod)
                        });
    
                       */
                        dispatch(geLoadStoredcardallSuccess(comData))
                    }
                }
                else {
                    const comData = { my_data_storedcardlist: [], my_data_geo:my_data_geo}
                    dispatch(getLoadStoredcardallError(comData))
                }
                //svj31 rend


            })
           
        ).catch(
            e=>dispatch(getLoadStoredcardallError(e))
        )
    }
}

/*svj31 end */